import { createStoreSync } from "@latticexyz/store-sync";
import { publicClient } from "./publicClient";
import { contract } from "./contract";
import { createStorageAdapter as createStashStorageAdapter } from "@latticexyz/store-sync/internal";
import { stash } from "./stash";
import worlds from "contracts/worlds.json";
import { chain } from "./chain";
import { MUDChain } from "@latticexyz/common/chains";
export let ready = false;
const currentBlockNumber = await publicClient.getBlockNumber();
export const storeSync = await createStoreSync({
  storageAdapter: async () => void 0,
  publicClient,
  address: contract.address,
  startBlock: currentBlockNumber,
});
ready = true;

// Separate sync to sync to stash since we are interested in historical state too in this case
const stashStorageAdapter = createStashStorageAdapter({ stash });
createStoreSync({
  storageAdapter: stashStorageAdapter,
  publicClient,
  address: contract.address,
  startBlock: BigInt(worlds[chain.id]?.blockNumber ?? 0),
  indexerUrl: (chain as MUDChain).indexerUrl,
}).then((result) => result.storedBlockLogs$.subscribe());
